import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { UnauthFooterCorner } from "./UnauthFooterCorner";

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

export const AuthPageLayout = ({ children }: AuthPageLayoutProps) => {
  const { palette } = useTheme();

  return (
    <Stack
      minHeight="100vh"
      bgcolor={palette.background.page}
      position="relative"
      alignItems="center"
      justifyContent="center"
    >
      <UnauthFooterCorner />
      {children}
    </Stack>
  );
};
